// App.js:
import React, { useEffect, useRef } from 'react';
// eslint-disable-next-line
import ReactPixel from 'react-facebook-pixel';
import { I18nextProvider } from 'react-i18next'; // Import the i18next provider
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'; // Import React Router
import './App.css';
import DownloadSection from './components/DownloadSection';
import Header from './components/Header';
import PurposeSection from './components/PurposeSection';
import i18n from './i18n'; // Import the i18n configuration
import Contact from './pages/Contact';
import Investors from './pages/Investors';
import ServiceLanding from './pages/ServiceLanding';
import TermsPrivacy from './pages/TermsPrivacy'; // Import TermsPrivacy page

function App() {
  const downloadSectionRef = useRef(null); // Reference for DownloadSection

  useEffect(() => {
    const advancedMatching = {};  // Optional advanced matching parameters
    const options = {
      autoConfig: true,
      debug: process.env.NODE_ENV === 'development',
    };

    // Initialize Facebook Pixel with your Pixel ID
    ReactPixel.init('611966488197226', advancedMatching, options);

    // Track the initial page view
    ReactPixel.pageView();

    // Load saved language from localStorage (if available), otherwise let LanguageDetector handle it
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  // Function to smoothly scroll to DownloadSection
  const scrollToDownload = () => {
    if (downloadSectionRef.current) {
      downloadSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Routes>
          {/* Main App */}
          <Route
            path="/"
            element={
              <div>
                {/* Pass scrollToDownload function to Header */}
                <Header scrollToDownload={scrollToDownload} />
                <PurposeSection />
                {/* Reference for DownloadSection */}
                <div ref={downloadSectionRef}>
                  <DownloadSection />
                </div>
              </div>
            }
          />

          {/* Terms & Privacy Policy Page */}
          <Route path="/Terms-Privacy" element={<TermsPrivacy />} />
          <Route path="/Investors" element={<Investors />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/s/:nameSlug/:shortId" element={<ServiceLanding />} />
          <Route path="/s/:serviceId" element={<ServiceLanding />} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
}

export default App;
